import Image from "@Components/Image";
import useTranslationHook from "hooks/useTranslationHook";
import { getRandomAvatar } from "../../avatars";
import styles from "./verifiedBadge.module.scss";
import Verified from "@Icons/Verified";
import wrapperHOC from "@Utils/wrapperHOC";

const AVATAR_CONFIGS = [
  { name: "verified-1", index: 0 },
  { name: "verified-2", index: 1 },
  { name: "verified-3", index: 2 },
];

const VerifiedBadge = () => {
  const { t } = useTranslationHook();

  return (
    <div className={styles.verifiedBadge}>
      <div className={styles.avatarStack}>
        {AVATAR_CONFIGS.map(({ name, index }) => (
          <Image
            key={name}
            src={getRandomAvatar(name, index)}
            alt=""
            width={42}
            height={42}
            className={styles.avatar}
          />
        ))}
        <span className={styles.checkmarkIcon}>
          <Verified fill />
        </span>
      </div>
      <span className={styles.verifiedText}>
        {t("propertypage.reviews.onlyverified")} {t("propertypage.reviews.studentreview")}
      </span>
    </div>
  );
};

export default wrapperHOC(VerifiedBadge, {
  componentName: "VerifiedBadge",
  showForChina: true,
});
